import React, { useContext } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { ActionIcon, Loader } from '@mummssoftware/common-ui';
import {
  HCPCSGlobalContext,
  DELETE_HCPCS_CHOICE,
  RECORD_DATA,
} from '@mummssoftware/global-context/HCPCSGlobalContext';
import { HCPCSDuration } from './HCPCSDuration';
import { HCPCSCode } from './HCPCSCode';
import { AddICDCode } from './AddICDCode';
import { iconStyle } from './constants';
import {
  HCPCSWrapper,
  FlexGapDiv,
  HCPCSMainDiv,
  FullWidthDiv,
} from './HCPCSWrapper';

export const HCPCSSelection = () => {
  const { hcpcsChoices, showHCPCSLoader, dispatchHCPCS } = useContext(
    HCPCSGlobalContext,
  );

  const onDeleteSelection = (choice: any) => {
    dispatchHCPCS({
      type: RECORD_DATA,
      payload: true,
    });
    dispatchHCPCS({
      type: DELETE_HCPCS_CHOICE,
      payload: choice.key,
    });
  };

  const getSelection = () =>
    hcpcsChoices && hcpcsChoices.length
      ? hcpcsChoices.map((choice: any) => {
          const key = choice.parentName
            ? `${choice.parentName} - ${choice.name}`
            : `${choice.name}`;
          return (
            choice.visible && (
              <FullWidthDiv key={key} id="hcpcs-section">
                <HCPCSMainDiv id="hcpcs-main-div">
                  <FlexGapDiv id="hcpcs-choice-div">
                    <ActionIcon
                      style={{ ...iconStyle, marginLeft: '-10px' }}
                      Icon={DeleteIcon}
                      onClick={() => onDeleteSelection(choice)}
                    />
                    {key}
                    <HCPCSDuration hcpcsChoice={choice} />
                    <HCPCSCode hcpcsChoice={choice} />
                  </FlexGapDiv>
                </HCPCSMainDiv>
                <AddICDCode hcpcsChoice={choice} />
              </FullWidthDiv>
            )
          );
        })
      : null;

  return (
    <>
      {showHCPCSLoader && <Loader />}
      <HCPCSWrapper id="hcps-wrapper">{getSelection()}</HCPCSWrapper>
    </>
  );
};
